<template>
 <div class="jobsList">
     <div class="navBar"><van-icon name="cross" @click="back()"/><span class="title">{{title}}</span></div>
     <div class="screenBox">
         <div class="search-box">
             <div class="search-tip" :style="focusObj" @click="focusInp">
                <img src="../../../assets/images/job/search.png"/>
                <span v-show="isShow" class="placeholder-tip">搜索岗位、公司</span>
             </div>
             <input @keyup.enter="getData('searchBtn')" @focus="focusInp" @blur="handleShow(0)" ref="searchInp" v-model="keyword" placeholder="" :style="widthObj"/>
             <span v-show="showCan" class="cancel-btn" @click="handleShow(1)">取消</span>
         </div>
         <div class="sort-box">
             <span class="allTip">全部</span>
             <div class="sort-span">
                 <span @click="showCityList" :class="isChooseCity?'active':''">{{activeCity.name}}</span>
                 <span @click="showScreenList" :class="screenNum>0?'active':''">筛选 {{screenNum?screenNum:''}}</span>
             </div>
         </div>
     </div>
     <van-list
        v-model="loading"
        :finished="finished"
        finished-text=" 一 已经到底了，更多内容即将上线 一 "
        :immediate-check="false"
        ref="list"
        @load="onLoad"
        v-show="isData"
    > 
        <div class="list-box">
            <div class="list-item" v-for="item in jobList" :key="item.id" @click="toDetail(item.id)">
                <div class="job-title">{{item.positionName}}</div>
                <div class="job-companey">{{item.companyName}}</div>
                <div class="job-dec">发布时间：{{item.publishTime}}</div>
                <div class="job-tags">
                    <span v-if="item.education!=null">{{screenList['学历'][item.education].name}}</span>
                    <span v-if="item.experience && screenList['工作经验'][item.experience]">{{screenList['工作经验'][item.experience].name}}</span>
                    <span v-if="item.positionType">{{positionType[item.positionType]}}</span>
                </div>
                <div class="job-salary" v-if="item.salaryEndNum<=2&&(item.salaryStartNum==null||item.salaryStartNum<=2)">2k以下</div>
                <div class="job-salary" v-else-if="item.salaryStartNum>=50">50k以上</div>
                <div class="job-salary" v-else>{{item.salaryStartNum?item.salaryStartNum+'-':''}}{{item.salaryEndNum?item.salaryEndNum:''}}k</div>
            </div>
        </div>
     </van-list>
     <div class="nomore" v-if="!isData">暂无数据</div>
     <div class="city-box" v-show="showCity" ref="city">
         <div class="navBar"><van-icon name="cross" @click="showCity=false"/><span class="title">选择城市</span></div>
         <div class="search-box">
             <div class="search-tip" :style="focusCityObj" @click="focusCityInp">
                <img src="../../../assets/images/job/search.png"/>
                <span v-show="isShowCity" class="placeholder-tip">搜索城市名/拼音</span>
             </div>
             <input @focus="focusCityInp" @blur="handleShowCity(0)" ref="searchCityInp" v-model="keywordCity" placeholder="" :style="widthCityObj"/>
             <span v-show="showCityCan" class="cancel-btn" @click="handleShowCity(1)">取消</span>
         </div>
         <div class="city-list" v-if="isShowSearch">
             <div class="cities">
                <span v-for="(item3,index3) in serachCityList"  @click="selectCity(item3,'search')" :key="index3" :class="activeCity.name==item3.name?'active':''">{{item3.name}}</span>
             </div>
         </div>
         <div class="city-list" v-if="!isShowSearch">
             <div class="loc-city city-items">
                <div class="index-title">定位城市</div>
                <div class="cities">
                    <span :class="activeCity.name==locationCity.name?'active':''"  @click="selectCity(locationCity)">{{locationCity.name}}</span>
                </div>
            </div>
            <div class="hot-city city-items">
                <div class="index-title">热门城市</div>
                <div class="cities">
                    <span :class="activeCity.name==item3.name?'active':''" v-for="(item3,index3) in hotCities"  @click="selectCity(item3)" :key="index3">{{item3.name}}</span>
                </div>
            </div>
            <div v-for="(item,index) in cityList" :key="index" class="city-items">
                <div :ref="index" class="index-title">{{index}}</div>
                <div class="cities">
                    <span :class="activeCity.name==item2.name?'active':''" @click="selectCity(item2)" v-for="(item2,index2) in item" :key="index2">{{item2.name}}</span>
                </div>
            </div>
         </div>
         <div class="fix-index" v-if="!isShowSearch">
             <div v-for="(item,index) in cityList" :key="index" @click="toScroll(index)">{{index}}</div>
         </div>
     </div>
     <div class="screen-box" v-show="showScreen">
        <div class="navBar"><van-icon name="cross" @click="hideScreen('cancel')"/><span class="title">筛选</span></div>
        <div class="city-list">
            <div v-for="(item,index) in screenList" :key="index" class="city-items">
                <div class="index-title">{{index}}</div>
                <div v-if="index=='学历'" class="cities">
                    <span :class="preScreenObj['currentEducationVal'].name==item2.name?'active':''" @click="selectScreen(index,item2)" v-for="(item2,index2) in item" :key="index2">{{item2.name}}</span>
                </div>
                <div v-else-if="index=='工作经验'" class="cities">
                    <span :class="preScreenObj['currentJobExpericeVal'].name==item2.name?'active':''" @click="selectScreen(index,item2)" v-for="(item2,index2) in item" :key="index2">{{item2.name}}</span>
                </div>
                <div v-else-if="index=='薪资范围'" class="cities">
                    <span :class="preScreenObj.currentJobSalaryVal==item2.name?'active':''" @click="selectScreen(index,item2)" v-for="(item2,index2) in item" :key="index2">{{item2.name}}</span>
                </div>
            </div>
         </div>
         <div class="btn-box">
             <span class="clean-btn" @click="cleanScreen()">清除</span>
             <span class="sure-btn" @click="sureScreen()">确定</span>
         </div>
     </div>
 </div>
</template>

<script>
import { Toast } from 'vant';

export default {
    name: "jobsList",
    data () {
        return {
            title:'就业应聘',
            isData:false,
            loading:false, // 上拉加载
            finished:false,
            loadMoreStatus: "more",
            keyword:null,
            keywordCity:'',
            isShow:true,
            isShowCity:true,
            showCan:false,
            showCityCan:false,
            // screenNum:0,
            showCity:false,
            showScreen:false,
            isChooseCity:false,
            isShowSearch:false,
            activeCity:{
                name:null,
                code:null
            },
            // activeScreenArr:[],
            focusObj:{
                left:'50%',
                transform:'translate(-50%,-50%)'
            },
            focusCityObj:{
                left:'50%',
                transform:'translate(-50%,-50%)'
            },
            widthObj:{
                width:'100%'
            },
            widthCityObj:{
                width:'100%'
            },
            jobList:[
            ],
            locationCity:{},
            cityList:{},
            hotCities:[],
            serachCityList:[],
            screenList:{
                '学历':[{name:'不限',type:0},{name:'高中',type:1},{name:'大专',type:2},{name:'本科',type:3},{name:'研究生',type:4},{name:'博士',type:5}],
                '工作经验':[{name:'不限',type:0},{name:'应届毕业生',type:1},{name:'3年以下',type:2},{name:'3-5年',type:3},{name:'5年以上',type:4}],
                '薪资范围':[
                    {
                        name:'不限',
                        start:'',
                        end:''
                    },
                    {
                        name:'2k以下',
                        start:0,
                        end:2
                    },
                     {
                        name:'2-4k',
                        start:2,
                        end:4
                    },
                    {
                        name:'4-6k',
                        start:4,
                        end:6
                    },
                    {
                        name:'6-8k',
                        start:6,
                        end:8
                    },
                    {
                        name:'8-10k',
                        start:8,
                        end:10
                    },
                    {
                        name:'10-12k',
                        start:10,
                        end:12
                    },
                    {
                        name:'12-14k',
                        start:12,
                        end:14
                    },
                    {
                        name:'14-16k',
                        start:14,
                        end:16
                    },
                    {
                        name:'16-18k',
                        start:16,
                        end:18
                    },
                    {
                        name:'18-20k',
                        start:18,
                        end:20
                    },
                    {
                        name:'20-30k',
                        start:20,
                        end:30
                    },
                    {
                        name:'30-50k',
                        start:30,
                        end:50
                    },
                    {
                        name:'50k以上',
                        start:50,
                        end:null
                    },
                ],
            },

            paging: {
                params: {
                    pageNum: 1,
                    pageSize: 5
                },
                total: 0,
                totalPages: 0,
            },
            positionType:['','全职','兼职','合伙人'],
            preScreenObj:{
                currentEducationVal:{name:'不限',type:0},
                currentJobExpericeVal:{name:'不限',type:0},
                currentJobSalaryVal:'不限',
                salaryEndNum:null,
                salaryStartNum:null,
                ednum:0,
                exnum:0,
                snum:0
            },
            screenObj:{
                currentEducationVal:{name:'不限',type:0},
                currentJobExpericeVal:{name:'不限',type:0},
                currentJobSalaryVal:'不限',
                salaryEndNum:null,
                salaryStartNum:null,
                ednum:0,
                exnum:0,
                snum:0
            },
        };
    },
    components: {
    },

    computed: {
        //筛选个数
        screenNum(){
            return this.screenObj.ednum + this.screenObj.exnum + this.screenObj.snum;
        }
    },

    watch:{
        //监听搜索城市字段
        'keywordCity'(newVal,oldVal){
            console.log(newVal,oldVal);
            this.searchCity()
        }
    },
    created(){
        console.log(2222);
    },

    mounted(){
        //监听浏览器返回
        if (window.history && window.history.pushState) {
            // 往历史记录里面添加一条新的当前页面的url
            history.pushState(null, null, document.URL);
            // 给 popstate 绑定一个方法 监听页面刷新
            window.addEventListener("popstate", this.back, false); //false阻止默认事件
        }
        //获取当前定位
        this.getLocatingCity();
        //获取城市筛选列表
        this.getCities();
    },
    destroyed(){
        window.removeEventListener("popstate", this.back, false); //false阻止默认事件
    },

    methods: {
        /**
         * 上拉加载
         */
        onLoad() {
            this.paging.params.pageNum = this.paging.params.pageNum*1 + 1
            this.getData('reachBottom')
        },

        //获取招聘列表
        getData(type) {
            return new Promise((resolve, reject)=>{
                if (type == 'searchBtn' && !(this.keyword.trim())) {
                    this.keyword = null;
                }

                if (type == 'searchBtn' || type == 'city'||type == 'screen') {
                    this.paging.params.pageNum = 1
                }
                const params = {
                    education: this.screenObj.currentEducationVal.type,
                    experience: this.screenObj.currentJobExpericeVal.type,
                    salaryEndNum: this.screenObj.salaryEndNum,
                    salaryStartNum: this.screenObj.salaryStartNum,
                    keyWord: this.keyword,
                    pageNum: this.paging.params.pageNum,
                    pageSize:this.paging.params.pageSize,
                    workPlaceCity:this.activeCity.code
                }
                this.$api.jobsList.findByCondition(params).then(res=>{
                    if (res.data && res.data.list) {
                        console.log(res.data.list,'res.data.list')
                        if (type === "reachBottom") {
                            this.jobList = this.jobList.concat(res.data.list);
                        } else {
                            this.jobList  = res.data.list;
                        }
                        this.paging.total = res.data.total;
                        this.paging.params.pageNum = res.data.pageNum
                        this.paging.totalPages = res.data.pages;
                        
                        // 数据全部加载完成
                        this.finished = res.data.isLastPage;
                        // 加载状态结束
                        this.loading = false;
                        this.isData = true;
                        resolve(res)
                    } else {
                        this.isData = false;
                        Toast({
                            message: res.message,
                            duration: 2000,
                        });
                         reject(res.message)

                    }

                }).catch(err=>{
                    reject(err)
                    console.log('err', err)
                })
            })
        },
        //返回
        back(){
            console.log(this.showScreen,this.showCity)
            if(this.showScreen){
                this.hideScreen('cancel')
                    // this.showScreen = false;
                if (window.history && window.history.pushState) {
                    // 往历史记录里面添加一条新的当前页面的url
                    history.pushState(null, null, document.URL);
                    // 给 popstate 绑定一个方法 监听页面刷新
                    window.addEventListener("popstate", this.back, false); //false阻止默认事件
                }
            }else if(this.showCity){
                this.showCity = false;
                if (window.history && window.history.pushState) {
                    // 往历史记录里面添加一条新的当前页面的url
                    history.pushState(null, null, document.URL);
                    // 给 popstate 绑定一个方法 监听页面刷新
                    window.addEventListener("popstate", this.back, false); //false阻止默认事件
                }
            }else{
                this.$router.push({
                    path: '/'
                });
            }
        },
        //搜索城市
        searchCity(){
            if(this.keywordCity){
                this.$api.jobsList.findCity({
                    name:this.keywordCity
                }).then(res=>{
                    if(res.code==0){
                        this.serachCityList = res.data;
                        this.isShowSearch = true;
                    }else{
                        console.log(res.message);
                    }
                })
            }else{
                this.serachCityList = [];
            }
        },
        //关闭筛选
        hideScreen(type){
            if(type=='cancel'){
                this.showScreen = false;
                this.preScreenObj = {
                    currentEducationVal:{name:this.screenObj.currentEducationVal.name,type:this.screenObj.currentEducationVal.type},
                    currentJobExpericeVal:{name:this.screenObj.currentJobExpericeVal.name,type:this.screenObj.currentJobExpericeVal.type},
                    currentJobSalaryVal:this.screenObj.currentJobSalaryVal,
                    salaryEndNum:this.screenObj.salaryEndNum,
                    salaryStartNum:this.screenObj.salaryStartNum,
                    ednum:this.screenObj.ednum,
                    exnum:this.screenObj.exnum,
                    snum:this.screenObj.snum
                };
            }else{
                this.showScreen = false;
                this.screenObj = {
                    currentEducationVal:{name:this.preScreenObj.currentEducationVal.name,type:this.preScreenObj.currentEducationVal.type},
                    currentJobExpericeVal:{name:this.preScreenObj.currentJobExpericeVal.name,type:this.preScreenObj.currentJobExpericeVal.type},
                    currentJobSalaryVal:this.preScreenObj.currentJobSalaryVal,
                    salaryEndNum:this.preScreenObj.salaryEndNum,
                    salaryStartNum:this.preScreenObj.salaryStartNum,
                    ednum:this.preScreenObj.ednum,
                    exnum:this.preScreenObj.exnum,
                    snum:this.preScreenObj.snum
                };
            }
        },
        //确定筛选
        sureScreen(){
            // this.showScreen = false;
            this.hideScreen();
            this.getData('screen');
        },
        //获取当前定位
        getLocatingCity() {
            this.$api.jobsList.getLocatingCity().then(res=>{
                if(res.code==0){
                    this.locationCity = res.data;
                    this.activeCity = res.data;
                    this.getData()
                }else{
                    console.log(res.message);
                    this.locationCity = {
                        name:'定位失败',
                        code:''
                    };
                    this.activeCity = {
                        name:'定位失败',
                        code:''
                    };
                }
            }).catch(err=>{
                console.log(err);
                this.locationCity = {
                    name:'定位失败',
                    code:''
                };
                this.activeCity = {
                    name:'定位失败',
                    code:''
                };
            })
        },
        //城市筛选列表字母匹配滚动条位置
        toScroll(name){
            this.$refs.city.scrollTop = this.$refs[name][0].offsetTop;
        },
        //跳转详情页
        toDetail(id){
            if(localStorage.getItem('token')){
                this.$router.push({
                    path: '/jobsDetail',
                    query: {
                        id: id
                    }
                })
            }else{
                this.$router.push({
                    path: '/login',
                    query: {
                        name: 'jobsDetail',
                        id:id
                    }
                })
            }
        },
        //清楚筛选
        cleanScreen(){
            this.preScreenObj = {
                currentEducationVal:{name:'不限',type:0},
                currentJobExpericeVal:{name:'不限',type:0},
                currentJobSalaryVal:'不限',
                salaryEndNum:'',
                salaryStartNum:'',
                ednum:0,
                exnum:0,
                snum:0
            };
        },
        //筛选项单项选择
        selectScreen(type,name){
            if(type=='学历'){
                this.preScreenObj.currentEducationVal = name;
                if(name.name!='不限'){
                    this.preScreenObj.ednum = 1;
                }else{
                    this.preScreenObj.ednum = 0;
                }
            }else if(type=='工作经验'){
                this.preScreenObj.currentJobExpericeVal = name;
                if(name.name!='不限'){
                    this.preScreenObj.exnum = 1;
                }else{
                    this.preScreenObj.exnum = 0;
                }
            }else{
                this.preScreenObj.currentJobSalaryVal = name.name;
                this.preScreenObj.salaryEndNum = name.end;
                this.preScreenObj.salaryStartNum = name.start;
                if(name.name!='不限'){
                    this.preScreenObj.snum = 1;
                }else{
                    this.preScreenObj.snum = 0;
                }
            }
        },
        //选择城市
        selectCity(name,type){
            this.activeCity = name;
            // this.showCity = false;
            this.back();
            this.isChooseCity = true;
            if(type=='search'){
                this.serachCityList = [];
                this.isShowSearch = false;
            }
            this.getData('city');
        },
        //显示城市列表
        showCityList(){
            this.showCity = true
        },
        //显示筛选列表
        showScreenList(){
            this.showScreen = true
        },
        //搜索框恢复取消
        handleShow(type){
            if(!this.keyword){
                this.isShow = true;
                this.focusObj.left='50%';
                this.focusObj.transform ='translate(-50%,-50%)';
                this.widthObj.width = '100%';
                this.showCan = false;
            }
            if(type){
                this.keyword = '';
                this.handleShow();
            }
        },
        //城市搜索框取消
        handleShowCity(type){
            if(!this.keywordCity){
                this.isShowCity = true;
                this.focusCityObj.left='50%';
                this.focusCityObj.transform ='translate(-50%,-50%)';
                this.widthCityObj.width = '100%';
                this.showCityCan = false;
                this.isShowSearch = false;
                this.serachCityList = [];
            }
            if(type){
                this.keywordCity = '';
                this.handleShowCity();
            }
        },
        //搜索框选中
        focusInp(){
            this.$refs.searchInp.focus();
            this.focusObj.left='30px';
            this.focusObj.transform ='translate(0,-50%)';
            this.isShow = false;
            this.widthObj.width = '90%';
            this.showCan = true;
        },
        //城市搜索框选中
        focusCityInp(){
            this.$refs.searchCityInp.focus();
            this.focusCityObj.left='30px';
            this.focusCityObj.transform ='translate(0,-50%)';
            this.isShowCity = false;
            this.widthCityObj.width = '90%';
            this.showCityCan = true;
            this.isShowSearch = true;
        },
        getQueryString(name) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
            var r = window.location.search.substr(1).match(reg);
            if (r != null) return unescape(r[2]);
            return null;
        },

        
        //获取城市列表
        getCities(){
            this.$api.jobsList.getCities().then(res=>{
                if(res.code==0){
                    this.cityList = res.data.citys;
                    this.hotCities = res.data.hotCitys
                }else{
                    console.log(res.message);
                }
            })
        }

    },



}

</script>


<style  scoped>
 @import "../asset/css/jobsList.css";
</style>
